import { FieldNamesMarkedBoolean } from 'react-hook-form';
import { IGlobalItem } from 'src/components/CreateGlobalItemWizard/types';
import { getDirtyFields } from '../getDirtyFields/getDirtyFields';
import { formUpdateGlobalItemRequestData } from '../formUpdateGlobalItemRequestData/formUpdateGlobalItemRequestData';
import { formatFlagsToRegulatoryStatements } from 'src/utils/regulatory-statements';

export const dirtyFieldsToFilter = {
  is_hfss: 'is_hfss',
  age_verification: 'age_verification',
  is_enhanced_bundle: 'is_enhanced_bundle',
} as const;

// Fields handled separately via formatFlagsToRegulatoryStatements, not the generic payload.
const REGULATORY_STATEMENT_FIELDS: Set<string> = new Set([
  dirtyFieldsToFilter.is_hfss,
  dirtyFieldsToFilter.age_verification,
]);

// `is_enhanced_bundle` is saved via its own instance-configuration mutation
// (see GlobalItemDetailsEditModal), so it's excluded from the generic update
// payload the same way the regulatory-statement fields are.
const EXCLUDED_FIELDS: Set<string> = new Set([...REGULATORY_STATEMENT_FIELDS, dirtyFieldsToFilter.is_enhanced_bundle]);

export const formUpdateDetailsPayload = (
  data: Partial<IGlobalItem>,
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<IGlobalItem>>>,
) => {
  const dirtyFieldsKeys = getDirtyFields(dirtyFields);
  const requestData = formUpdateGlobalItemRequestData(
    dirtyFieldsKeys.filter((item) => !EXCLUDED_FIELDS.has(item)),
    data,
  );

  const hasRegulatoryStatementChanges = dirtyFieldsKeys.some((item) => REGULATORY_STATEMENT_FIELDS.has(item));

  return {
    data: JSON.stringify({
      ...requestData,
      ...(hasRegulatoryStatementChanges ? formatFlagsToRegulatoryStatements(data) : {}),
    }),
    ...(dirtyFieldsKeys.includes('image') && { files: data.image || null }), // files included only if they are changed
  };
};
